// Copy from tailwind config if a breakpoint changed.
const cleanedBreakpoints = {
  sm: '576',
  md: '768',
  lg: '992',
  xl: '1280',
  xxl: '1400',
  tablet: '768',
  desktop: '1280',
};
function getBreakpointStart(breakpoint) {
  if (!(breakpoint in cleanedBreakpoints)) {
    throw new Error(`Breakpoint ${breakpoint} not found. Please check your tailwind config.`);
  }
  return cleanedBreakpoints[breakpoint];
}
function innerWidthBetween(min, max) {
  return window.innerWidth >= min && window.innerWidth < max;
}
function isMobileBreakpoint() {
  return innerWidthBetween(0, getBreakpointStart('tablet'));
}
function isTabletBreakpoint() {
  return innerWidthBetween(getBreakpointStart('tablet'), getBreakpointStart('desktop'));
}
/**
 * Returns the current ScreenSize.
 */
function returnScreenSize() {
  if (isMobileBreakpoint()) {
    return 'isMobile';
  }
  else if (isTabletBreakpoint()) {
    return 'isTablet';
  }
  else {
    return 'isDesktop';
  }
}

export { innerWidthBetween as i, returnScreenSize as r };
